// extracted by mini-css-extract-plugin
export default {"rtf_render":"rtf_render__TqdWC"};